<script setup lang="ts">
defineProps<{
  anchor: string;
  index: number;
  title: string;
}>();
</script>

<template>
  <section
    :id="anchor"
    :aria-labelledby="`${anchor}-title`"
    class="flex scroll-mt-8 flex-col gap-4 border-t border-gray-200 pt-8"
  >
    <h2
      :id="`${anchor}-title`"
      class="text-xl font-medium text-text-primary-900 md:text-2xl"
    >
      {{ index }}. {{ title }}
    </h2>

    <slot />
  </section>
</template>
